export const cuttoffTime: string = "13:00";
export const baseShippingCost: number = 3000;
export const freeShippingThreshold: number = 30000;
export const config = import.meta.env.CONFIG;
